import { useMemo } from "react";

import { CRYPTO_LOCALE_OPTIONS } from "../utils";

interface GetCryptoEstimatedQuantityParams {
  isNotional: boolean;
  quantity: number;
  midPriceValue: number;
}

export const getCryptoEstimatedQuantity = ({
  isNotional,
  quantity,
  midPriceValue,
}: GetCryptoEstimatedQuantityParams): string => {
  if (isNotional) {
    if (!quantity) {
      return "-";
    }
    if (!midPriceValue) {
      return "-";
    }
    return (quantity / midPriceValue).toLocaleString(
      "en-US",
      CRYPTO_LOCALE_OPTIONS,
    );
  }

  if (Number.isNaN(quantity) || !quantity) {
    return "-";
  }
  return quantity.toLocaleString("en-US", CRYPTO_LOCALE_OPTIONS);
};

export const useCryptoEstimatedQuantity = ({
  isNotional,
  quantity,
  midPriceValue,
}: GetCryptoEstimatedQuantityParams) => {
  const estimatedQuantity = useMemo(
    () =>
      getCryptoEstimatedQuantity({
        isNotional,
        quantity,
        midPriceValue,
      }),
    [isNotional, quantity, midPriceValue],
  );

  return { estimatedQuantity };
};
